import { apiGet, toAbsoluteUrl } from "./client";

/** Нормализуем ответ бэкенда к одной форме, чтобы UI не знал про image_url. */
function normalizeArticle(raw) {
  if (!raw) return null;

  return {
    id: String(raw.id),
    title: raw.title ?? "",
    date: raw.date ?? "",
    excerpt: raw.text ?? "",
    body: raw.full_text || raw.text || "",
    image: toAbsoluteUrl(raw.image_url),
  };
}

export function fetchNewsList({ lang, limit = 50, page = 1, signal }) {
  return apiGet("", { params: { lang, page, limit }, signal }).then((data) =>
    (data ?? []).map(normalizeArticle).filter(Boolean),
  );
}

export function fetchNewsItem({ id, lang, signal }) {
  return apiGet(`/${id}`, { params: { lang }, signal }).then(normalizeArticle);
}
